import { render } from "./RenameFormModal.vue?vue&type=template&id=e8c50410&scoped=true&ts=true"
import script from "./RenameFormModal.vue?vue&type=script&lang=ts"
export * from "./RenameFormModal.vue?vue&type=script&lang=ts"

import "./RenameFormModal.vue?vue&type=style&index=0&id=e8c50410&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8c50410"]])

export default __exports__